module.exports = __webpack_public_path__ + "assets/img/shizhong--blue.c611ec52.png";